/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BalenaDeviceNotificationMessage } from "./BalenaDeviceNotificationMessage";
import {
    BalenaDeviceNotificationMessageFromJSON,
    BalenaDeviceNotificationMessageFromJSONTyped,
    BalenaDeviceNotificationMessageToJSON,
} from "./BalenaDeviceNotificationMessage";
import type { TaskInfoUpdateMessage } from "./TaskInfoUpdateMessage";
import {
    TaskInfoUpdateMessageFromJSON,
    TaskInfoUpdateMessageFromJSONTyped,
    TaskInfoUpdateMessageToJSON,
} from "./TaskInfoUpdateMessage";
import type { DeviceLiveLogUpdateSrm } from "./DeviceLiveLogUpdateSrm";
import {
    DeviceLiveLogUpdateSrmFromJSON,
    DeviceLiveLogUpdateSrmFromJSONTyped,
    DeviceLiveLogUpdateSrmToJSON,
} from "./DeviceLiveLogUpdateSrm";
import type { DeviceStatusSrm } from "./DeviceStatusSrm";
import {
    DeviceStatusSrmFromJSON,
    DeviceStatusSrmFromJSONTyped,
    DeviceStatusSrmToJSON,
} from "./DeviceStatusSrm";
import type { CoreSnapshotMessage } from "./CoreSnapshotMessage";
import {
    CoreSnapshotMessageFromJSON,
    CoreSnapshotMessageFromJSONTyped,
    CoreSnapshotMessageToJSON,
} from "./CoreSnapshotMessage";
import type { DeviceAlertMessage } from "./DeviceAlertMessage";
import {
    DeviceAlertMessageFromJSON,
    DeviceAlertMessageFromJSONTyped,
    DeviceAlertMessageToJSON,
} from "./DeviceAlertMessage";
import type { TestMessage } from "./TestMessage";
import {
    TestMessageFromJSON,
    TestMessageFromJSONTyped,
    TestMessageToJSON,
} from "./TestMessage";

/**
 * Methods that clients subscribe to, that are invoked by the hub
 * @export
 * @interface DeviceHubOutputMethods
 */
export interface DeviceHubOutputMethods {
    /**
     *
     * @type {TestMessage}
     * @memberof DeviceHubOutputMethods
     */
    testMessage?: TestMessage;
    /**
     *
     * @type {DeviceStatusSrm}
     * @memberof DeviceHubOutputMethods
     */
    deviceStatus?: DeviceStatusSrm;
    /**
     *
     * @type {DeviceLiveLogUpdateSrm}
     * @memberof DeviceHubOutputMethods
     */
    deviceLiveLogUpdate?: DeviceLiveLogUpdateSrm;
    /**
     *
     * @type {DeviceAlertMessage}
     * @memberof DeviceHubOutputMethods
     */
    deviceAlertMessage?: DeviceAlertMessage;
    /**
     *
     * @type {TaskInfoUpdateMessage}
     * @memberof DeviceHubOutputMethods
     */
    taskInfoUpdateMessage?: TaskInfoUpdateMessage;
    /**
     *
     * @type {CoreSnapshotMessage}
     * @memberof DeviceHubOutputMethods
     */
    coreSnapshotMessage?: CoreSnapshotMessage;
    /**
     *
     * @type {BalenaDeviceNotificationMessage}
     * @memberof DeviceHubOutputMethods
     */
    balenaDeviceNotificationMessage?: BalenaDeviceNotificationMessage;
}

/**
 * Check if a given object implements the DeviceHubOutputMethods interface.
 */
export function instanceOfDeviceHubOutputMethods(
    value: object,
): value is DeviceHubOutputMethods {
    return true;
}

export function DeviceHubOutputMethodsFromJSON(
    json: any,
): DeviceHubOutputMethods {
    return DeviceHubOutputMethodsFromJSONTyped(json, false);
}

export function DeviceHubOutputMethodsFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceHubOutputMethods {
    if (json == null) {
        return json;
    }
    return {
        testMessage:
            json["testMessage"] == null
                ? undefined
                : TestMessageFromJSON(json["testMessage"]),
        deviceStatus:
            json["deviceStatus"] == null
                ? undefined
                : DeviceStatusSrmFromJSON(json["deviceStatus"]),
        deviceLiveLogUpdate:
            json["deviceLiveLogUpdate"] == null
                ? undefined
                : DeviceLiveLogUpdateSrmFromJSON(json["deviceLiveLogUpdate"]),
        deviceAlertMessage:
            json["deviceAlertMessage"] == null
                ? undefined
                : DeviceAlertMessageFromJSON(json["deviceAlertMessage"]),
        taskInfoUpdateMessage:
            json["taskInfoUpdateMessage"] == null
                ? undefined
                : TaskInfoUpdateMessageFromJSON(json["taskInfoUpdateMessage"]),
        coreSnapshotMessage:
            json["coreSnapshotMessage"] == null
                ? undefined
                : CoreSnapshotMessageFromJSON(json["coreSnapshotMessage"]),
        balenaDeviceNotificationMessage:
            json["balenaDeviceNotificationMessage"] == null
                ? undefined
                : BalenaDeviceNotificationMessageFromJSON(
                      json["balenaDeviceNotificationMessage"],
                  ),
    };
}

export function DeviceHubOutputMethodsToJSON(
    value?: DeviceHubOutputMethods | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        testMessage: TestMessageToJSON(value["testMessage"]),
        deviceStatus: DeviceStatusSrmToJSON(value["deviceStatus"]),
        deviceLiveLogUpdate: DeviceLiveLogUpdateSrmToJSON(
            value["deviceLiveLogUpdate"],
        ),
        deviceAlertMessage: DeviceAlertMessageToJSON(
            value["deviceAlertMessage"],
        ),
        taskInfoUpdateMessage: TaskInfoUpdateMessageToJSON(
            value["taskInfoUpdateMessage"],
        ),
        coreSnapshotMessage: CoreSnapshotMessageToJSON(
            value["coreSnapshotMessage"],
        ),
        balenaDeviceNotificationMessage: BalenaDeviceNotificationMessageToJSON(
            value["balenaDeviceNotificationMessage"],
        ),
    };
}
